import { utagViewArtificialPageView } from 'features/tealium';
import { getQueryStringValue } from 'utilities/browser';

function initCouponModal (couponCode, isCouponCodeValid) {

	const trackArtificalPageViewEvent = utagViewArtificialPageView();
	// if url has coupon query string, open the coupon information in a modal popup

	if (getQueryStringValue('a') || getQueryStringValue('b')) {

		const couponHdr = document.querySelector('#couponHdr');
		const couponSmallPrint = document.querySelector('#couponSmallPrint');

		function setModalHeight () {

			const couponHdrText = couponHdr?.innerText.length >= 1;

			if (getQueryStringValue('a')) {

				return couponHdrText ? 507 : 236;

			}
			if (getQueryStringValue('b')) {

				return couponHdrText ? 391 : 236;

			}

		}

		if (couponSmallPrint) {

			if (couponSmallPrint?.innerText.length >= 700) {

				couponSmallPrint.classList.add('scrollCouponPrint');

			} else {

				couponSmallPrint.classList.remove('scrollCouponPrint');

			}

		}

		$('body').lpModal({
			onInit: true,
			width: 788,
			height: setModalHeight(),
			content: $('#couponOverlay'),
			lpModalClass: 'lpModal--alt1--orangeBG',
			openEvt: () => {

				const lpModalClose = document.getElementById('lpModalClose');
				if (lpModalClose && lpModalClose.innerHTML) {

					lpModalClose.innerHTML = '<span class="lpIcon-close02 lpIcon-close02--lightBlack"></span>';

				}

				$('#continueShoppingBtn').on('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

			},
			closeEvt: () => {

				trackArtificalPageViewEvent({ pageName: '' });

			}
		});

		// Show coupon applied message if coupon was successfully applied
		if (isCouponCodeValid) {

			const couponCodeWrapper = document.querySelector('.promoCouponCode__innerWrapper');
			const couponApplied = document.querySelector('.promoCouponCode__applied');

			if (couponCodeWrapper && couponApplied?.dataset.couponCode.toLowerCase() === couponCode.toLowerCase()) {

				couponApplied.classList.remove('hidden');
				couponCodeWrapper.classList.add('hidden');

			}

		}

	}

}

export default initCouponModal;
